import React from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { useAuth } from "../lib/auth.jsx";
import analytics from "../lib/analytics";

export default function SiteFooter() {
  const { user } = useAuth();
  return (
    <footer className="bg-[#111827] text-slate-300 py-14">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-md bg-white text-[#111827] flex items-center justify-center">
              <Activity className="w-5 h-5" />
            </div>
            <div>
              <div className="font-heading font-extrabold text-white">RapidCare SA</div>
              <div className="text-[10px] tracking-widest text-slate-400 uppercase">Clinical Reference</div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            South African clinical decision support for doctors, registrars, nurses, and medical students.
          </p>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3 text-sm">Platform</h4>
          <ul className="text-sm space-y-2">
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/signup" className="hover:text-white" onClick={() => { if (!user) analytics.signupStart("/signup"); }}>Start free trial</Link></li>
            <li><Link to="/login" className="hover:text-white">Sign in</Link></li>
            <li><Link to="/feedback" className="hover:text-white" data-testid="footer-feedback">Feedback</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3 text-sm">Legal</h4>
          <ul className="text-sm space-y-2">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about">About</Link></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-white" data-testid="footer-cookie-policy">Cookie Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-white" data-testid="footer-disclaimer">Medical Disclaimer</Link></li>
          </ul>
          <div className="text-sm mt-3 pt-3 border-t border-slate-800" data-testid="footer-contact">
            <div className="text-xs text-slate-500 uppercase tracking-widest font-semibold">Contact</div>
            <a href="mailto:rapidcaresasupport@gmail.com" className="text-slate-300 hover:text-white break-all">rapidcaresasupport@gmail.com</a>
          </div>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3 text-sm">Disclaimer</h4>
          <p className="text-xs text-slate-300 leading-relaxed">
            RapidCare SA is a clinical reference tool for verified SA healthcare professionals. This tool is for reference only and requires a qualified medical practitioner to approve any treatments. Always verify against the current SAMF and NDoH guidelines. <Link to="/disclaimer" className="underline">Read more</Link>.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 mt-10 pt-6 border-t border-slate-800 text-xs text-slate-400 flex flex-col md:flex-row justify-between gap-2" data-testid="footer-copyright">
        <div>© {new Date().getFullYear()} RapidCare SA. All rights reserved. Independently developed; not affiliated with HPCSA, NDoH, SAMF or any specialty society unless stated. Reference content is curated against published SA guidelines and placed under ongoing clinical review.</div>
        <div>Made for South African healthcare professionals.</div>
      </div>
    </footer>
  );
}
